import DiscoveryShell from "./DiscoveryShell.js";

/**
 * Wraps a route element in the app shell, so pages stay unaware of the layout
 * and the topbar + sidebar are declared in one place.
 *
 * @param {React.ReactNode} element - The route's element.
 * @param {{ sidebar?: boolean, variant?: "light"|"dark", disableGutters?: boolean,
 *   bottomTabBar?: boolean, footer?: "expanded"|"expanded-dark"|"minimal"|"none" }} [options]
 *   Forwarded to `DiscoveryShell`. Full-bleed marketing pages pass
 *   `disableGutters` because they own their own padding; in-app utility pages
 *   pass `footer: "minimal"`; creator pages pass `footer: "expanded-dark"` for
 *   the dark footer (the default expanded footer is light).
 * @returns {JSX.Element}
 */
export const withShell = (element, options = {}) => (
  <DiscoveryShell {...options}>{element}</DiscoveryShell>
);
